import React from 'react'
import { useParams } from 'react-router'
import Loader from '../../components/Loader'
import { useTotalLeave } from '../../hooks/CompanyConfiguration/useTotalLeave'
import TotalLeaveForm from '../Masters/TotalLeaveForm'

function EditTotalLeave() {
  const { totalLeave, getTotalLeave } = useTotalLeave()

  const params = useParams()

  React.useEffect(() => {
    getTotalLeave({ totalLeaveId: params.totalLeaveId })
  }, [params.totalLeaveId])

  return <> {totalLeave ? <TotalLeaveForm totalLeave={totalLeave} /> : <Loader />} </>
}

export default EditTotalLeave
